;(function($){

    function SocialShare() {
   	 	var _ =  this;

      $(".anu").ayoshare({
        counter: false,
        button: {
            google : true,
            facebook : true,
            pinterest : true,
            linkedin : false,
            twitter : true,
            flipboard : false,
            email : false,
            whatsapp : false,
            telegram : false,
            line : false,
            bbm : false,
            viber : false,
            sms : false
        }
      });
    }

   
   	new SocialShare();

}(jQuery));
 
 
 
 
